import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { Stack, Typography } from '@mui/material';
import { FormFieldContext, FormTextField, useFormContext } from '@metarouter-private/mr-mui';

import PipelineMultiSelect from './PipelineMultiSelect';

export default function CloneIntegrationForm({ defaultName, existingNames, pipelines }) {
  const { setValue } = useFormContext();

  // Setting defaultName and making form submittable so we can automatically submit
  // can't use regular useEffect bc form context must be established
  useEffect(() => {
    requestAnimationFrame(() => {
      setValue('name', defaultName, { shouldDirty: true, shouldValidate: true });
    });
  }, [defaultName, setValue]);

  const uniqueNameRule = {
    validate: value => {
      if (existingNames.includes(value)) {
        return 'An integration with this name already exists';
      }
      return true;
    },
  };

  return (
    <Stack spacing={3}>
      <FormFieldContext name="name" label="Integration Name" required rules={uniqueNameRule}>
        <FormTextField />
      </FormFieldContext>

      {!isEmpty(pipelines) && (
        <Stack spacing={1}>
          <Typography variant="subtitle2">Stage to Pipelines (optional)</Typography>
          <Typography variant="body2" color="text.secondary">
            Select the pipeline(s) where you&apos;d like the cloned integration to be staged.
          </Typography>
          <PipelineMultiSelect pipelines={pipelines} />
        </Stack>
      )}
    </Stack>
  );
}

CloneIntegrationForm.propTypes = {
  defaultName: PropTypes.string.isRequired,
  existingNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  pipelines: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
